// Faucet event definitions — emitted from the inline portfolio faucet banner
// (and reusable by the onboarding faucet stage if it ever opts in via the
// `source` discriminator). See spec 080-portfolio-faucet § Telemetry.

import type { EventDefinition } from './navigation';

export type FaucetClaimSource = 'portfolio_banner' | 'onboarding' | 'faucet_modal';

export type FaucetClaimInitiatedProperties = {
  source: FaucetClaimSource;
  walletAddress: string;
};

export type FaucetClaimSucceededProperties = {
  source: FaucetClaimSource;
  walletAddress: string;
  amount: number;
  signature: string;
};

export type FaucetClaimFailureReason = 'cooldown' | 'other';

export type FaucetClaimFailedProperties = {
  source: FaucetClaimSource;
  walletAddress: string;
  reason: FaucetClaimFailureReason;
};

export const FAUCET_CLAIM_INITIATED: EventDefinition<FaucetClaimInitiatedProperties> = {
  name: 'faucet_claim_initiated',
};

export const FAUCET_CLAIM_SUCCEEDED: EventDefinition<FaucetClaimSucceededProperties> = {
  name: 'faucet_claim_succeeded',
};

export const FAUCET_CLAIM_FAILED: EventDefinition<FaucetClaimFailedProperties> = {
  name: 'faucet_claim_failed',
};
